import { useEffect, useState } from 'react';

export const useOrientation = () => {
  const [orientation, setOrientation] = useState({
    screenOrientation: '',
  });

  const setScreenOrientation = () => {
    if (window.matchMedia('(orientation: portrait)').matches) {
      setOrientation((prev) => ({
        screenOrientation: 'portrait',
      }));
    }

    if (window.matchMedia('(orientation: landscape)').matches) {
      setOrientation((prev) => ({
        screenOrientation: 'landscape',
      }));
    }
  };
  useEffect(() => {
    window.addEventListener('resize', setScreenOrientation);
    return () => {
      window.removeEventListener('resize', setScreenOrientation);
    };
  }, []);
  return { orientation };
};
